import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectIsIE = createSelector(
  (state: RootState) => state.layout.browser.isIE,
  (isIE: boolean) => isIE
)

export default selectIsIE
